import { FullscreenService } from './../../core.module/modules/fullscreen.module/fullscreen.service';
import { ScheduleData } from './schedule-data.interface';
import { PlayerGroup } from './../../shared/sdk/models/PlayerGroup';
import { ScheduleDownloadStatus } from './schedule-download-status.interface';
import { GlobalPropertiesService } from './../../core.module/services/global-properties.service';
import { CategoryRotation } from './../../shared/sdk/models/CategoryRotation';
import { Router } from '@angular/router';
import { LoopBackAuth, Player, PlayerApi, SDKToken, CategoryRotationApi, RealTime } from '../../shared/sdk/index';
import { Injectable, EventEmitter } from '@angular/core';
import { LoopBackConfig } from '../../shared/sdk/index';
import { DataURLS } from '../../shared/base.url';
import { PlayerLogService } from './PlayerLog.service';
import { PlayerManagementService } from './playermanagement.service';
import * as _ from 'lodash';
import { md5 } from '../../shared/md5';
import { BackendStatus } from './backendstatus.interface';
import { ScheduleService } from './schedule.service';
import { Subscription } from 'rxjs/Subscription';
import { DataService } from '../../core.module/services/data.service';

// player specific globals
@Injectable()
export class PlayerService {

  // connection status
  public _isConnected = false;
  get isConnected() {
    if (this.pms.isPlayerManaged) {
      return this.backendStatus.isConnected;
    } else {
      return true;  // always connected if not managed player
    }
  }
  set isConnected(val) {
    this._isConnected = val;
  }

  // activation status
  public isActivated = false;


  // restart vars
  public hasPendingRestart = false;
  public restartMode = '';

  // last mem usage message from host process
  public processMemUsage = {
    rss: '0 Bytes',
    heapTotal: '0 Bytes',
    heapUsed: '0 Bytes',
    external: '0 Bytes'
  };


  public serialNumber: string;
  public hardwareHash: string;
  public currentPlayer: Player;
  // public token: any;

  public isInitalizing = true;
  public isUpdatingSchedule = false;
  public isInvalidLogin = false;
  public invalidLoginMessage = '';
  public isPlayerLoaded = false;
  public version = ' (web edition)';
  public isGettingPlayer = false;
  public lastScheduleCheck = null;
  public nextScheduleCheck = null;
  public isRealtimeConnecting = false;

  public onPlayerLoaded = new EventEmitter<Player>();
  public onPlayerUpdated = new EventEmitter<Player>();

  public onRequestToOpenCloseMenu = new EventEmitter<boolean>();

  // player stauts
  public onBackendStatusChange = new EventEmitter<BackendStatus>();

  // schedule download progress

  public defaultDownloadProgress: ScheduleDownloadStatus = {
    totalFiles: 0,
    filesLeft: 0,
    currentFile: '',
    downloadPath: '',
    currentFileState: {
      left: 30,
      speed: 250,
      percent: 50,
      total: 25,
      transferred: 588
    },
    rawState: null,
    waiting: true
  };

  public downloadProgress = _.cloneDeep(this.defaultDownloadProgress);

  // create default backend status
  public backendStatus: BackendStatus = {
    host: '',
    serial: '',
    hardwareHash: '',
    version: '',
    isInitalizing: false,
    isInvalidLogin: false,
    invalidLoginMessage: '',
    isUpdatingSchedule: false,
    isLoggingIn: false,
    isLoggedIn: false,
    hasCache: false,

    // other vars
    nextReloginDate: null,
    tokenExpirationDate: null,

    // os info
    osinfo: null,

    // network info
    authMacAddress: '',
    macAddress: '',
    lanIp4: '',
    wanIp4: '',
    lanIp6: '',
    wanIp6: '',
    lastHeartbeatSent: null,
    upTime: null,
    upTimeDate: null,
    isConnected: true,

    // schedule info
    lastScheduleCheck: null,
    nextScheduleCheck: null,

    // override settings on player
    realTimeEnabled: false,
    isRealtimeConnecting: false,
    programUpdateTime: -1,
    scheduleUpdateTime: -1,
    heartbeatTime: -1

  };

  public browserStartDate = new Date();

  // vars that are different if it is a web or managed player
  // these could be set from a backend status update, or a from player web player startup
  public useRealtime = false;
  public programUpdateTime = null;
  public scheduleUpdateTime = null;
  public heartbeatTime = null;
  public host = '';

  // TEMP FROM SCHEDULE SERVICE
  // subscriptions
  public watchCategoryRotationsSub$: Subscription = new Subscription();
  public realtimeConectionChange$: Subscription;
  public currentUserChange$: Subscription;
  public watchPlayerSub$: Subscription = new Subscription();
  public watchPlayerGroupSub$: Subscription = new Subscription();
  // events
  public loadingPlayer: boolean;
  public loadingPlayerGroups: boolean;
  public playerGroups: any;
  public categoryRotationIDList: string[] = [];

  public realtimeEvents: { time: Date; description: string; }[] = [];


  constructor(
    public dataService: DataService,
    public playerApi: PlayerApi,
    public authService: LoopBackAuth,
    public logger: PlayerLogService,
    public pms: PlayerManagementService,
    public router: Router,
    public categoryRotationApi: CategoryRotationApi,
    public gps: GlobalPropertiesService,
    public scheduleService: ScheduleService,
    public realTime: RealTime,
    public fullScreenService: FullscreenService
  ) {
    LoopBackConfig.setBaseURL(DataURLS.BASE_URL);
    LoopBackConfig.setApiVersion(DataURLS.API_VERSION);

    // this.realTime.onReady().take(1).subscribe(val => {
    //   if (this.realtimeConectionChange$) {
    //     this.realtimeConectionChange$.unsubscribe();
    //     this.realtimeConectionChange$ = null;
    //   }

    this.realtimeConectionChange$ = this.dataService.realtimeConnectionChange$.subscribe((data) => {
      if (data.connected) {
        this.isRealtimeConnecting = false;
        if (this.useRealtime) {
          logger.info('player', 'Realtime is now connected');
          this.watchPlayer();
        }
      }

      if (data.connecting) {
        logger.info('player', 'Realtime is connecting');
        this.isRealtimeConnecting = true;
      }
    });

    // });
    // process received messages
    if (this.pms.isPlayerManaged && this.pms.received$) {
      this.pms.received$.subscribe(async (msg) => {
        const data = JSON.parse(msg.data);

        if (data && data.command) {
          this.processMessageFromBackend(data);
        } else {
          if (data && !data.response) {
            this.logger.error('player', 'Message was received without the command property: ', JSON.stringify(data));
          }
        }
      });

    }

    scheduleService.scheduleUpdated$.subscribe(scheduleData => {
      if (this.pms.isPlayerManaged) {
        this.pms.sendScheduleData(scheduleData);
      }
    });

    // start watching rotations when a new schedule is loaded
    scheduleService.onScheduleLoaded.subscribe((scheduleData: ScheduleData) => {
      // send new schedule to backend schedule is updated via realtime

      this.lastScheduleCheck = this.scheduleService.currentScheduleState.lastScheduleCheck;
      this.nextScheduleCheck = this.scheduleService.currentScheduleState.nextScheduleCheck;

      if (this.useRealtime) {
        logger.info('player', 'Update realtime monitoring to reflect current schedule');
        this.watchRoationsByRest(scheduleData.categoryRotations);
        this.watchPlayerGroupsByRest(this.currentPlayer.playerGroups);
      }

    });

    // check if browser ready has been sent already
    if (pms.isPlayerManaged) {
      if (this.pms.connected && !this.pms.sentBrowserReady) {
        this.pms.sendBrowserReady();
      }
    }

    // listen to if connection changes, send browser ready
    this.pms.connectionStatusChanged.subscribe((connected: boolean) => {
      if (pms.isPlayerManaged) {
        if (this.pms.connected && !this.pms.sentBrowserReady) {
          this.pms.sendBrowserReady();
        }
      }
    });
  }

  async updateBackendStatus(): Promise<void> {
    const status = await this.getBackendStatus();
    if (status) {
      this.loadBackendStatus(status);
    }

  }

  async getBackendStatus(): Promise<BackendStatus> {
    const status = await this.pms.getStatus();
    return status;
  }

  loadBackendStatus(status: BackendStatus) {

    // update current statuses from backend message
    if (this.pms.isPlayerManaged) {
      this.backendStatus = status;

      // set global vars
      this.isInitalizing = status.isInitalizing;
      this.isInvalidLogin = status.isInvalidLogin;
      this.invalidLoginMessage = status.invalidLoginMessage;
      this.programUpdateTime = status.programUpdateTime;
      this.scheduleUpdateTime = status.programUpdateTime;
      this.isUpdatingSchedule = status.isUpdatingSchedule;
      this.serialNumber = status.serial;
      this.hardwareHash = status.hardwareHash;
      this.lastScheduleCheck = status.lastScheduleCheck;
      this.nextScheduleCheck = status.nextScheduleCheck;
      this.heartbeatTime = status.heartbeatTime;
      this.isRealtimeConnecting = status.isRealtimeConnecting;

      this.version = this.backendStatus.version;

      if (!this.isActivated || !!(status.isInvalidLogin && status.isConnected)) {
        this.isActivated = false;
      }


      // // stop monitoring if we were
      // if (!status.realTimeEnabled && this.useRealtime) {
      //   this.stopMonitoringSchedule();
      // }

      // // start monitoring if we were not already
      // if (status.realTimeEnabled && !this.useRealtime) {
      //   this.startMonitoringSchedule('realtime');
      // }



      // this.useRealtime = status.realTimeEnabled;
      this.host = status.host;

      this.onBackendStatusChange.emit(this.backendStatus);

    }
  }


  async setAuthToken(tokenId) {
    // set token for future API calls
    const sdkToken = new SDKToken({ id: tokenId });
    this.authService.setToken(sdkToken);
    localStorage.setItem('tokenid', tokenId); // save token to survive page refresh
  }

  async clearAuthToken() {
    localStorage.removeItem('tokenid');
    this.authService.clear();
  }

  async loadPlayer(player: Player) {
    if (player) {
      this.isActivated = player.Activated; // set global activation flag
      this.isPlayerLoaded = true;
      this.currentPlayer = player;
      this.serialNumber = this.currentPlayer.playerSerial.serial;
      localStorage.setItem('playerid', player.id); // save playerid to local storage to survive page refresh
      this.useRealtime = player.useRealtime;

      if (player.realtimeThrottleTime === null) {
        player.realtimeThrottleTime = 3;
      }

      if (player.downloadThrottleSpeed === null) {
        player.downloadThrottleSpeed = 500;
      }

      if (player.programUpdateWindowStart === null) {
        player.programUpdateWindowStart = new Date(2018, 1, 1, 1);
      } else {
        player.programUpdateWindowStart = new Date(player.programUpdateWindowStart);
      }
      if (player.programUpdateWindowEnd === null) {
        player.programUpdateWindowEnd = new Date(2018, 1, 1, 3);
      } else {
        player.programUpdateWindowEnd = new Date(player.programUpdateWindowEnd);
      }

      if (player.scheduleUpdateWindowStart === null) {
        player.scheduleUpdateWindowStart = new Date(2018, 1, 1, 1);
      } else {
        player.scheduleUpdateWindowStart = new Date(player.scheduleUpdateWindowStart);
      }
      if (player.scheduleUpdateWindowEnd === null) {
        player.scheduleUpdateWindowEnd = new Date(2018, 1, 1, 3);
      } else {
        player.scheduleUpdateWindowEnd = new Date(player.scheduleUpdateWindowEnd);
      }
      if (player.dailyRestartTime === null) {
        player.dailyRestartTime = new Date(2018, 1, 1, 3);
      } else {
        player.dailyRestartTime = new Date(player.dailyRestartTime);
      }

      this.gps.appGlobal.currentPlayerZip = this.currentPlayer.Zip;

      // use player settings if this is a web player
      if (!this.pms.isPlayerManaged) {
        this.programUpdateTime = player.ProgramUpdateInterval;
        this.scheduleUpdateTime = player.ScheduleUpdateInterval;
        this.useRealtime = !!(player.allowRealtimeForWebPlayer && player.useRealtime);
        this.host = window.location.origin;
      }

      if (this.useRealtime) {
        this.startMonitoringSchedule('realtime');
      } else {
        this.stopMonitoringSchedule();
      }

      this.logger.info('player', `Player data loaded`);

      // say we're done!
      this.onPlayerLoaded.emit(player);
    }
  }

  formatBytes(bytes, decimals = 0) {
    if (bytes === 0) { return '0 Bytes'; }
    const k = 1024,
      dm = decimals || 2,
      sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB'],
      i = Math.floor(Math.log(bytes) / Math.log(k));
    return parseFloat((bytes / Math.pow(k, i)).toFixed(dm)) + ' ' + sizes[i];
  }

  async getPlayer(playerId: string): Promise<Player> {
    this.isGettingPlayer = true;
    try {
      const player: Player = <any>await this.playerApi.findById(playerId,
        {
          include: [{ 'kanvasUser': 'roles' }, 'parentContributor', 'tags', 'locationAddress', 'playerSerial', 'playerGroups']
        }).toPromise();

      return player;
    } catch (error) {
      this.logger.error('player', 'Could not retreive player');
    } finally {
      this.isGettingPlayer = false;
    }
  }

  calcHardwareHash(): string {
    // do hw hash calc
    return this.hardwareHash;
  }

  async processMessageFromBackend(message) {
    const response: any = {
      key: message.key
    };

    // log everything except ping and schedule data (because it's huge!)
    if (message.command !== 'ping' && message.command !== 'sendLogEntry') {
      const cleanMsg = _.omit(message.value, 'scheduleData');
      this.logger.log('player', `Received message from backend: ${JSON.stringify(message.command)}`);
    }

    if (message.command === 'setAuthToken') {
      await this.setAuthToken(message.value.token);
    }

    if (message.command === 'clearAuthToken') {
      await this.clearAuthToken();
    }

    if (message.command === 'statusUpdate') {
      this.loadBackendStatus(message.value);
    }

    if (message.command === 'ping') {
      this.logger.log('player', 'Ping Received. Sending back pong');
      this.pms.pong();
    }

    // if (message.command === 'goToState') {
    //   this.processStateChange(message);
    // }

    if (message.command === 'onlineStatus') {
      this.isConnected = message.value;
    }

    if (message.command === 'loadPlayer') {
      await this.loadPlayer(message.value.player);
    }

    if (message.command === 'loadSchedule') {
      this.scheduleService.loadSchedule(message.value.scheduleData);
    }

    if (message.command === 'stopSchedule') {
      this.scheduleService.stop();
    }

    if (message.command === 'openMenu') {
      this.onRequestToOpenCloseMenu.next(true);
    }

    if (message.command === 'closeMenu') {
      this.onRequestToOpenCloseMenu.next(false);
    }

    if (message.command === 'getScheduleHash') {
      response.scheduleHash = this.scheduleService.currentScheduleState.scheduleData.scheduleHash || '';
    }

    if (message.command === 'sendLogEntry') {
      this.logger.addToLog(message.value.level, message.value.source, message.value.value);
    }

    if (message.command === 'sendRealtimeLogEntry') {

      const rte = {
        time: new Date(),
        description: message.value
      };
      this.addRealtimeEventToList(rte);
    }

    if (message.command === 'signalRestart') {
      this.hasPendingRestart = true;
      this.restartMode = message.value;
      this.onRequestToOpenCloseMenu.next(false);
    }

    if (message.command === 'signalRestartCanceled') {
      this.hasPendingRestart = false;
      this.restartMode = '';
    }


    if (message.command === 'sendScheduleDownloadStatus') {
      if (message.value && message.value.currentFileState) {
        this.downloadProgress = message.value;
      }
    }

    if (message.command === 'updateMemUsage') {

      if (message.value) {

        if (message.value.rss) {
          this.processMemUsage.rss = this.formatBytes(message.value.rss);
        }

        if (message.value.heapTotal) {
          this.processMemUsage.heapTotal = this.formatBytes(message.value.heapTotal);
        }

        if (message.value.heapUsed) {
          this.processMemUsage.heapUsed = this.formatBytes(message.value.heapUsed);
        }

        if (message.value.external) {
          this.processMemUsage.external = this.formatBytes(message.value.external);
        }

      }

    }

    if (message.command === 'goToRunPage') {
      this.router.navigate(['player/run']);
    }

    if (message.command === 'setNoSerial') {
      this.isInitalizing = true;
      this.isInvalidLogin = false;
      this.serialNumber = null;
      this.currentPlayer = null;
      this.hardwareHash = message.value.hwHash;
      this.scheduleService.resetScheduleState();
      this.router.navigate(['/player/activate']);
    }

    if (message.command === 'getStatus') {
      response.value = {
        isPlaying: this.scheduleService.currentScheduleState.isPlaying,
        scheduleHash: this.scheduleService.currentScheduleState.scheduleData.scheduleHash
      };
    }


    // play command received for triggerd screens
    if (message.command === 'triggerScreen') {
      const rotationItemId = message.value.rotationItemId;
      this.scheduleService.overridePlayingScreen(rotationItemId, true);  // submit override request
    }


    // if the message contains a key, send response
    if (message.key) {
      this.pms.postMessage(response);
    }
  }


  //#region Realtime Stuff
  /**
   *
   * Start realtime monitoring
   * @param {*} mode
   * @memberof PlayerService
   */
  async startMonitoringSchedule(mode) {

    // if (this.realtimeConectionChange$) {
    //   this.realtimeConectionChange$.unsubscribe();
    //   this.realtimeConectionChange$ = new Subscription();
    // }




    if (!this.dataService.realtimeStarted) {
      this.isRealtimeConnecting = true;
      this.dataService.connectRealtime();
    } else {
      this.isRealtimeConnecting = false;
    }

    this.logger.info('player', `Start monitoring for schedule changes. mode: ${mode}`);
    if (mode === 'realtime' && this.useRealtime) {
      this.watchPlayer(); // will listen for IO broadcasts about changes to schedule
    }

    if (mode === 'polling') {
      this.getSchedulesPulling(); // will pull schedule down in by timer
    }



  }

  addRealtimeEventToList(rte) {
    this.realtimeEvents.unshift(rte);

    if (this.realtimeEvents.length > this.logger.maxLogLength) {
      this.realtimeEvents.pop(); // remove last item from list
    }
  }

  stopMonitoringSchedule() {
    if (this.dataService.realtimeStarted) {
      this.dataService.disconnectRealtime();
    }

    this.isRealtimeConnecting = false;


    // remove watch for player changes
    if (this.watchPlayerSub$) {
      this.watchPlayerSub$.unsubscribe();
    }

    // remove watch for rotation changes
    if (this.watchCategoryRotationsSub$) {
      this.watchCategoryRotationsSub$.unsubscribe();
      this.watchCategoryRotationsSub$ = new Subscription();
    }

    if (this.currentUserChange$) {
      this.currentUserChange$.unsubscribe();
      this.currentUserChange$ = null;
    }

    if (this.realtimeConectionChange$) {
      this.realtimeConectionChange$.unsubscribe();
      this.realtimeConectionChange$ = null;
    }


  }

  async getSchedulesPulling() {

    try {

      // get player
      this.currentPlayer = await this.playerApi.getCurrent({
        include: [{ 'playerGroups': { 'scheduleRotations': ['categoryRotations', 'scheduleTimeframes'] } }, 'playerSerial', 'tags', 'locationAddress']
      }).toPromise();

      // get groups this player is part of
      this.playerGroups = [...this.scheduleService.currentScheduleState.scheduleData.playerGroups, ...this.scheduleService.currentScheduleState.scheduleData.inactivePlayerGroups];

    } catch (error) {
      this.logger.error('player', `Error getting schdules by pulling`, error);
    }
  }

  async watchPlayer() {

    if (!this.currentPlayer) {
      this.logger.info('player', 'Realtime is enabled, but Player not loaded yet skipping watching until ready');
      return;
    }

    if (this.realTime.connection.isConnected()) {
      this.logger.info('player', `Realtime - Start watching for player and schedule changes`);

      if (this.watchPlayerSub$) {
        this.watchPlayerSub$.unsubscribe();
        this.watchPlayerSub$ = new Subscription();
      }

      // get player by id, then start watching assoiated rotations
      try {

        // load changes to player only every 3 seconds
        const watchPlayerSub = this.dataService.realTime.IO.on(`Player:${this.currentPlayer.id}`).debounceTime(this.currentPlayer.realtimeThrottleTime * 1000).subscribe(async (value) => {





          let rte;
          const valueJson = JSON.parse(value);
          if (valueJson.for && valueJson.for === 'PlayerGroup') {

            // if (cr && this.auth.getToken().id.substring(0, 8) !== valueJson.key) {
            this.logger.info('player', `Received IO update: Player Group '${valueJson.name}' has changed`);
            rte = {
              time: new Date(),
              description: `Player Group '${valueJson.name}' Change detected`
            };

            this.addRealtimeEventToList(rte);

            if (this.pms.isPlayerManaged) {
              this.pms.updateSchedule();
            } else {
              this.scheduleService.updateSchedule(this.currentPlayer.id, false);
            }

          } else {
            this.logger.info('player', `Received IO update: A Player Setting has changed`);

            rte = {
              time: new Date(),
              description: 'Player Setting Change'
            };
            this.addRealtimeEventToList(rte);

            const player: Player = await this.getPlayer(this.currentPlayer.id);

            if (player) {
              this.loadPlayer(player);
              if (this.pms.isPlayerManaged) {
                this.pms.setPlayer(player);
              }
              if (player.Activated && !this.scheduleService.currentScheduleState.isPlaying) {
                this.scheduleService.play();
              }
            }
          }

        });

        this.watchPlayerSub$.add(watchPlayerSub); // add to watch list

        // start watching rotations now if a schedule is avaiable
        if (this.scheduleService.currentScheduleState.scheduleData.categoryRotations) {
          this.watchRoationsByRest(this.scheduleService.currentScheduleState.scheduleData.categoryRotations); // watch rotations in schedule
        }

        if (this.currentPlayer.playerGroups) {
          this.watchPlayerGroupsByRest(this.currentPlayer.playerGroups);
        }

      } catch (error) {
        this.logger.error('player', `Error while watching for player changes over realtime: '${this.currentPlayer.id}' `, error);
      }


    } else {
      this.logger.info('player', 'Realtime is not connecect yet, will start monitoring when connectinon is avaialbe');
    }


  }

  async watchPlayerGroupsByRest(playerGroups: PlayerGroup[]) {
    this.logger.info('player', `Realtime - Start watching for playergroup changes`);

    // stop watching any rotations
    if (this.watchPlayerGroupSub$) {
      this.watchPlayerGroupSub$.unsubscribe();
      this.watchPlayerGroupSub$ = new Subscription();
    }

    // start watching each rotation for changes
    for (const playerGroup of playerGroups) {
      const playerGroupSub = this.dataService.realTime.IO.on(`PlayerGroup:${playerGroup.id}`).debounceTime(this.currentPlayer.realtimeThrottleTime * 1000).subscribe(value => {
        // reload if key different than first8 of token
        const valueJson = JSON.parse(value);
        const pg = playerGroups.find(item => { return item.id === valueJson.id; });
        // if (cr && this.auth.getToken().id.substring(0, 8) !== valueJson.key) {
        this.logger.info('player', `Received IO update: Player Group '${pg.name}' has changed`);

        const rte = {
          time: new Date(),
          description: `Player Group '${pg.name}' Change detected`
        };
        this.addRealtimeEventToList(rte);

        if (this.pms.isPlayerManaged) {
          this.pms.updateSchedule();
        } else {
          this.scheduleService.updateSchedule(this.currentPlayer.id, false);
        }

        // }
      });

      this.watchPlayerGroupSub$.add(playerGroupSub);
    }
  }

  async watchRoationsByRest(categoryRotations: CategoryRotation[]) {
    this.logger.info('player', `Realtime - Start watching for rotation changes`);

    // stop watching any rotations
    if (this.watchCategoryRotationsSub$) {
      this.watchCategoryRotationsSub$.unsubscribe();
      this.watchCategoryRotationsSub$ = new Subscription();
    }

    // start watching each rotation for changes
    for (const rotation of categoryRotations) {
      const rotationSub = this.dataService.realTime.IO.on(`CategoryRotation:${rotation.id}`).debounceTime(this.currentPlayer.realtimeThrottleTime * 1000).subscribe(value => {
        // reload if key different than first8 of token
        const valueJson = JSON.parse(value);
        const cr = categoryRotations.find(item => { return item.id === valueJson.id; });
        // if (cr && this.auth.getToken().id.substring(0, 8) !== valueJson.key) {
        this.logger.info('player', `Received IO update: Rotation '${cr.name}' has changed`);

        const rte = {
          time: new Date(),
          description: `Rotation '${cr.name}' Change detected`
        };
        this.addRealtimeEventToList(rte);

        if (this.pms.isPlayerManaged) {
          this.pms.updateSchedule();
        } else {
          this.scheduleService.updateSchedule(this.currentPlayer.id, false);
        }

        // }
      });

      this.watchCategoryRotationsSub$.add(rotationSub);
    }

  }

  //#endregion Realtime Stuff

}






// WEBPACK FOOTER //
// ./src/app/player/services/player.service.ts